import { render } from "./newDeal.vue?vue&type=template&id=27e565fa&scoped=true"
import script from "./newDeal.vue?vue&type=script&lang=js"
export * from "./newDeal.vue?vue&type=script&lang=js"

import "./newDeal.vue?vue&type=style&index=0&id=27e565fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e565fa"]])

export default __exports__